export default {
  // 标题和描述
  title: "用户分享的画布",
  sharedCanvas: "分享的画布",
  userUid: "用户",
  welcomeText: "欢迎使用",

  // 系统描述
  systemDescription: "以链上交易溯源及匿名身份穿透为核心，打击涉虚拟货币新型犯罪的一站式查控平台。",

  // 功能列表
  feature1: "行业领先的地址标签库",
  feature2: "赋能行业超前的安全响应能力",
  feature3: "多维度助推案件质效提升",
  feature4: "调证目标一键直达",

  // 输入框
  enterAccessPassword: "请输入访问密码",

  // 时间相关
  expirationTime: "到期时间",

  // 按钮
  confirm: "确认",

  // 错误信息
  canvasExpired: "该画布分享已过期或者已关闭分享，暂时无法访问",
};
